module.exports = __webpack_public_path__ + "img/face-kiss-closed-eyes.561709af.svg";